import React, { useContext } from 'react';

import { AxiosPromise } from 'axios';

import { useApplicationBuildContext } from '@context/ApplicationBuildContext';
import { ReactFCC } from '@types';
import { noopObject } from '@utils/general';

import { IHttpClientRequest } from '../client';

import { useMemoizedClient } from './useMemoizedClient';

export interface IHttpClientContext {
  callHttpClient: <TResult>(params: IHttpClientRequest) => AxiosPromise<TResult>;
  callParfumsHttpClient: <TResult>(params: IHttpClientRequest) => AxiosPromise<TResult>;
}

const defaultContextValue: IHttpClientContext = {
  callHttpClient: noopObject,
  callParfumsHttpClient: noopObject,
};

export const HttpClientContext = React.createContext<IHttpClientContext>(defaultContextValue);

export const HttpClientContextProvider: ReactFCC = ({ children }) => {
  const {
    settings: { websiteHostAddress, checkoutGatewayBaseUrlAddress },
  } = useApplicationBuildContext();

  return (
    <HttpClientContext.Provider value={useMemoizedClient(checkoutGatewayBaseUrlAddress, websiteHostAddress)}>
      {children}
    </HttpClientContext.Provider>
  );
};

export const useHttpClientContext = () => useContext(HttpClientContext);
